define('app/visualizations/ErrorView',['require','glu/itemView','hbs!./ErrorView.hbs'],function(require) {
	'use strict';

	var ItemView = require('glu/itemView');

	/**
	 * Generic error view that is displayed whenever a report is in a non runnable state.
	 *
	 * For now this is only used by the grid view but could easily be extended to all visualization types.
	 */
	return ItemView.extend({
		template: require('hbs!./ErrorView.hbs'),

		templateHelpers: function() {
			var self = this;

			return {
				noColumns: self.options.hasNoColumns,
				invalidFilters: self.options.hasInvalidFilters,
				noMetrics: self.options.noMetrics,
				noSegments: self.options.noSegments
			};
		}
	});

});

